(function ($){
  console.log()
  $('.elementor-field-type-submit button').click(function(){      
    if($(this).closest('.elementor-form').find('.elementor-acceptance-field').length > 0) {
      $(this).closest('.elementor-form').find('.elementor-acceptance-field').each(function(){
        if($(this).is(':checked')){
          $(this).removeClass('invalid')
        } else {
          $(this).addClass('invalid')
        }
      });
    }
  });

  $('.elementor-acceptance-field').change(function(){      
    if($(this).is(':checked')){
      $(this).removeClass('invalid')
    } else {
      $(this).addClass('invalid')
    }
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/forms.js